/*
 * @Descripttion: 任务中心State
 * @Author: 曹博
 * @Date: 2023-12-08 09:26:07
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-08 09:32:10
 */
import { ActionType, CustomAction } from '../../global'

export interface taskcenterState {
  dataSource: { data: any[]; total: number }
  dataSourceLoading: boolean
  pages: {
    pageNo: number
    pageSize: number
  }
}

// 默认数据
export const defaultState: taskcenterState = {
  // 表格数据 总条数
  dataSource: { data: [], total: 100 },
  dataSourceLoading: true,
  // 初始化分页
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
}

type Action = ActionType<taskcenterState>

export default function reducer(
  state = defaultState,
  action: CustomAction<Action>,
): taskcenterState {
  let arr = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      arr.dataSource = action.payload.dataSource
      arr.pages.pageNo = action.payload.pageNo
      return arr
    case 'setPagesAction':
      arr.pages = action.payload
      return arr
    case 'setDataSourceLoadingAction':
      arr.dataSourceLoading = action.payload
      return arr
    case 'reloadStateAction':
      arr = action.payload
      return arr
    default:
      return state
  }
}

// 设置数据
export const setDataSourceAction = (param: {
  dataSource: { data: any[]; total: number }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 切换分页
export const setPagesAction = (param: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPagesAction',
  payload: param,
})

// loading
export const setDataSourceLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setDataSourceLoadingAction',
  payload: param,
})

export const reloadStateAction = (
  param: taskcenterState,
): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: param,
})
/*
 * @Descripttion: 任务中心State
 * @Author: 曹博
 * @Date: 2023-12-08 09:26:07
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-08 09:32:10
 */
import { ActionType, CustomAction } from '../../global'

export interface taskcenterState {
  dataSource: { data: any[]; total: number }
  dataSourceLoading: boolean
  pages: {
    pageNo: number
    pageSize: number
  }
}

// 默认数据
export const defaultState: taskcenterState = {
  // 表格数据 总条数
  dataSource: { data: [], total: 100 },
  dataSourceLoading: true,
  // 初始化分页
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
}

type Action = ActionType<taskcenterState>

export default function reducer(
  state = defaultState,
  action: CustomAction<Action>,
): taskcenterState {
  let arr = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      arr.dataSource = action.payload.dataSource
      arr.pages.pageNo = action.payload.pageNo
      return arr
    case 'setPagesAction':
      arr.pages = action.payload
      return arr
    case 'setDataSourceLoadingAction':
      arr.dataSourceLoading = action.payload
      return arr
    case 'reloadStateAction':
      arr = action.payload
      return arr
    default:
      return state
  }
}

// 设置数据
export const setDataSourceAction = (param: {
  dataSource: { data: any[]; total: number }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 切换分页
export const setPagesAction = (param: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPagesAction',
  payload: param,
})

// loading
export const setDataSourceLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setDataSourceLoadingAction',
  payload: param,
})

export const reloadStateAction = (
  param: taskcenterState,
): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: param,
})
